export const CLARA_MAX_FILE_SIZE_BYTES = 6 * 1024 * 1024;
